module.exports = __webpack_public_path__ + "img/4.a7a1a871.jpg";